import { Star, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card } from '@/components/ui/card';
import { UserBadges } from './TrustBadge';

const initials = (u) => `${(u?.first_name || '?')[0]}${(u?.last_name || '')[0] || ''}`.toUpperCase();

export const JobeurCard = ({ jobeur, service }) => {
  const name = jobeur.first_name ? `${jobeur.first_name} ${jobeur.last_name || ''}` : jobeur.jobeur_name;
  return (
    <Card
      data-testid="jobeur-card"
      className="p-4 bg-white border-[#E2E8F0] hover:border-[#C7E2FF] hover:shadow-[0_10px_24px_rgba(11,18,32,0.10)] active:scale-[0.99]"
      style={{ transition: 'box-shadow 180ms ease, border-color 180ms ease, transform 120ms ease' }}
    >
      <div className="flex items-start gap-3">
        <Avatar className="h-14 w-14 flex-shrink-0 border-2 border-[#EAF3FF]">
          {jobeur.photo_base64 && <AvatarImage src={jobeur.photo_base64} alt="" />}
          <AvatarFallback className="bg-gradient-to-br from-[#1677F2] to-[#0E4FA6] text-white font-semibold">
            {initials(jobeur)}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <Link
            to={`/jobeur/${jobeur.id || jobeur.jobeur_id}`}
            className="block font-semibold text-[#0B1220] hover:text-[#1677F2] truncate"
            data-testid="jobeur-card-name-link"
          >
            {name}
          </Link>
          {service && (
            <p className="text-xs text-slate-600 mt-0.5 truncate">{service.title}</p>
          )}
          <div className="flex items-center gap-2 mt-1 text-xs text-slate-600">
            <Star size={12} className="fill-[#F7D618] text-[#F7D618]" />
            <span className="font-mono-num font-semibold text-[#0B1220]">{(jobeur.rating_avg || jobeur.jobeur_rating_avg || 0).toFixed(1)}</span>
            <span>({jobeur.rating_count || jobeur.jobeur_rating_count || 0})</span>
            {(jobeur.city || jobeur.jobeur_city) && (
              <>
                <span className="text-slate-300">·</span>
                <span className="flex items-center gap-1"><MapPin size={11} /> {jobeur.commune || jobeur.jobeur_commune || jobeur.city || jobeur.jobeur_city}</span>
              </>
            )}
          </div>
          <div className="mt-2">
            <UserBadges user={{
              phone_verified: jobeur.phone_verified ?? jobeur.jobeur_phone_verified,
              id_verified: jobeur.id_verified ?? jobeur.jobeur_id_verified,
              trusted_jobeur: jobeur.trusted_jobeur,
            }} size="xs" />
          </div>
        </div>
      </div>
    </Card>
  );
};
